module.exports = __webpack_public_path__ + "img/offline.019ee6f8.png";